// ./src/App.tsx
import React, { Suspense, useEffect } from 'react';

import { LoadScript } from '@react-google-maps/api';
import { Toaster } from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { io } from 'socket.io-client';

import '@locales/index';
import 'react-toastify/dist/ReactToastify.css';

import { LoadingSuspense } from './components/index';
import { ConfigAuth } from './config';
import AppProvider from './hooks';
import Routes from './routes';

import { GlobalStyles } from './styles';

// const socket = io('http://localhost:3333');
const socket = io('https://rebox2.com.br/');

const App: React.FC = () => {
  const { push } = useHistory();
  const handleSocket = () => {
    socket.on('called_notification', ({ license_plate }) => {
      const notification = new Notification('Um novo chamado foi aberto.', {
        icon: 'https://i.ibb.co/yXXRF63/icon.png',
        body: `Chamado para a placa ${license_plate} em aberto, clique para ver.`,
        requireInteraction: true,
      }) as any;
      notification.onclick = (event: any) => {
        event.preventDefault();
        window.focus();
        push('/chamados/acionamentos');
      };
    });
  };

  useEffect(() => {
    handleSocket();
  }, []);

  return (
    <>
      <Suspense fallback={<LoadingSuspense />}>
        <AppProvider>
          <LoadScript
            googleMapsApiKey={ConfigAuth.google.keys.maps}
            libraries={['places']}
            language="pt_BR"
          >
            <Routes />
          </LoadScript>
          <GlobalStyles />
          <Toaster />
          <ToastContainer />
        </AppProvider>
      </Suspense>
    </>
  );
};

export default App;
